import React, { useState } from 'react';
import { ReactComponent as AngleUp } from '../../assets/svg/AngleUp.svg';
import { ReactComponent as DeleteContentIcon } from '../../assets/svg/DeleteContentIcon.svg';
import MDEditor from '@uiw/react-md-editor';

function ListOfQuotes({ quotes, setQuotes, quotesTextError, label = 'List of solution quotes' }: { quotes: any; setQuotes: any; quotesTextError: any; label?: string }) {
	const [showQuotes, setShowQuotes] = useState(true);

	const addNewQuote = () => {
		setQuotes((prev: any) => [...prev, '']);
	};

	return (
		<div className='flex flex-col flex-1'>
			<div className='p-5 rounded-[10px] border border-primaryViolet'>
				<div className='flex flex-row items-center  mb-2 gap-4'>
					<p className='flex-1 text-left text-primaryViolet text-[20px] leading-6 font-semibold'>{label}</p>
					<div className={`${showQuotes ? 'rotate-180' : 'rotate-0'} transition cursor-pointer h-9 w-9 flex items-center justify-center rounded-full border border-greyMedium`} onClick={() => setShowQuotes(!showQuotes)}>
						<AngleUp style={{ color: '#5E639B' }} />
					</div>
				</div>
				{showQuotes && (
					<div>
						{quotes?.map((quote: any, index: number) => (
							<Quote quotes={quotes} setQuotes={setQuotes} quote={quote} quotesTextError={quotesTextError} index={index} key={index} />
						))}

						{quotes.length < 3 && (
							<div className='pointer mt-4 flex w-full items-center justify-center rounded-xl  bg-mudPurple py-4 text-[16px] left-5 font-semibold text-white hover:bg-deepPurple' onClick={() => addNewQuote()}>
								Add quote {quotes.length + 1}
							</div>
						)}
					</div>
				)}
			</div>
		</div>
	);
}

export default ListOfQuotes;

const Quote = ({ quotes, setQuotes, quote, index, quotesTextError }: { quotes: any; setQuotes: any; quote: any; index: number; quotesTextError: any }) => {
	const [showQuotes, setShowQuotes] = useState(true);

	const _removeValue = (arr: any[], x: any) => {
		arr.splice(x, 1);
		return arr;
	};

	const handleTextChange = (value: any) => {
		let newList = JSON.parse(JSON.stringify(quotes));
		newList[index] = value;
		setQuotes(newList);
	};

	const removeQuote = (index: number) => {
		let newList = [...quotes];
		newList = _removeValue(newList, index);
		setQuotes(newList);
	};

	return (
		<div className='mb-4'>
			<div className='bg-lightBG rounded-xl px-4 py-2 border border-lightBG hover:border-primaryViolet'>
				<div className=' '>
					<div
						className=' flex flex-row items-center '
						onClick={(e) => {
							e.preventDefault();
							e.stopPropagation();
						}}
					>
						<p className='text-primaryViolet font-semibold text-[18px] leading-5 text-left flex-1'>Quote {index + 1}</p>

						<div className='flex flex-row pointer justify-between items-center' onClick={() => removeQuote(index)}>
							<p className='text-redError text-[16px] font-medium mr-3'>Delete</p>
							<DeleteContentIcon fill='#FF747F' />
						</div>
						<button className={`flex items-center justify-center h-10 w-10 rounded-full ${showQuotes ? 'bg-white ' : 'bg-primaryViolet'} ml-[35px] transition cursor-pointer`} onClick={() => setShowQuotes((prev) => !prev)} style={{ transform: !showQuotes ? 'rotate(180deg)' : 'none' }}>
							<AngleUp color={showQuotes ? '#9392AD' : '#ffffff'} />
						</button>
					</div>
					{showQuotes && (
						<div className='mt-2'>
							<div className=''>
								<MDEditor data-color-mode='light' height={90} value={quote} onChange={(value: any) => handleTextChange(value)} preview='edit' />
							</div>
							<p className='text-redError font-medium text-[14px] leading-5 h-5 '>{quotesTextError && quote === '' ? '* This field is required' : ''}</p>
						</div>
					)}
				</div>
			</div>
		</div>
	);
};
